<div class="page-root">
  <div class="title">
    <mat-icon>delete</mat-icon>
  </div>

  <div class="title">
    <div class="typo-h1">{{ 'profile.appointmentDetails.cancelDialog.title' | transloco }}</div>
  </div>

  <div class="body">
    <div class="body-text">
      {{
        'profile.appointmentDetails.cancelDialog.description' | transloco: {
          appointment: (data.appointmentDto.startTime | customDate:'dd.MM.yyyy HH:mm') + " - " + (data.appointmentDto.endTime | customDate:'HH:mm')
        }
      }}
    </div>

    <div class="reason">
      <div class="body-text-bold">{{ "form.label.cancellationReason" | transloco }}</div>
      <mat-form-field class="form-field">
        <textarea [formControl]="cancellationReasonForm" matInput rows="2"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="actions">
    <app-text-button (click)="cancelAppointment()" [text]="'profile.appointmentDetails.button.cancel' | transloco" colorVariant="cancelled" leadingIcon="delete" type="rounded"></app-text-button>
    <app-text-button [mat-dialog-close]="false" [text]="'button.cancel' | transloco" colorVariant="outlined-neutral" leadingIcon="close"></app-text-button>
  </div>
</div>
